require('./Pagination.scss');

const React = require('react'),
    {PropTypes} = require('react'),
    NumberUtils = require('utils/NumberUtils'),
    Constants = require('constants/AppConstants'),
    EMPTY_ACTION = ()=> {},
    PaginationItem = require('./PaginationItem/PaginationItem');


const Pagination = React.createClass({displayName: "Pagination",

    propTypes: {
        currentPage: PropTypes.number,
        maxPage: PropTypes.number,
        maxVisibleButtonPages: PropTypes.number,
        onNextPage: PropTypes.function,
        onPreviousPage: PropTypes.function,
        onClickPage: PropTypes.function
    },

    getInitialState() {
        const {currentPage, maxVisibleButtonPages} = this.props;

        return {
            startIndex: getStartIndex(currentPage, maxVisibleButtonPages)
        };
    },

    _onPreviousPage() {
        this.setState(prevState => {
            prevState.startIndex =  prevState.startIndex - 1;
            return prevState;
        });
    },

    _onNextPage() {
        this.setState(prevState => {
            prevState.startIndex =  prevState.startIndex + 1;
            return prevState;
        });
    },

    render() {
        const {currentPage, maxPage, onClickPage, maxVisibleButtonPages} = this.props;
        const {startIndex} = this.state;
        const maxVisibleButtonPagination = maxVisibleButtonPages || Constants.MAX_VISIBLE_BUTTON_PAGES;
        let i, paginationListEl = [], arrowLeftEl, arrowRightEl;

        const singlePage = maxPage <= 1;
        const isVisibleButtonMorePages = NumberUtils.isGreater(maxPage, maxVisibleButtonPagination);
        const isVisibleButtonLeftMorePages = startIndex > 0;

        if (isVisibleButtonMorePages && isVisibleButtonLeftMorePages) {
            arrowLeftEl = (
                React.createElement("i", {onClick: this._onPreviousPage, className: "pagination-start material-icons"}, "keyboard_arrow_left")
            );
        }

        let pageVisibles = 0;

        for (i = 0; i < maxPage ; i++) {
            if (isVisibleButtonMorePages && i < startIndex) {
                continue;
            } else {
                pageVisibles++;
            }

            if (pageVisibles > maxVisibleButtonPagination) {
                break;
            }

            paginationListEl.push(
                React.createElement(PaginationItem, {onClick: onClickPage ? onClickPage.bind(this, i) : EMPTY_ACTION, 
                                pageNumber: i + 1, 
                                isActive: i === +currentPage}

                )
            );
        }

        if (isVisibleButtonMorePages && i < maxPage) {
            arrowRightEl = (
                React.createElement("i", {onClick: this._onNextPage, className: "pagination-start material-icons"}, "keyboard_arrow_right")
            );
        }

        return (
            React.createElement("div", {style: {display: singlePage ? 'none' : 'flex'}, className: "pagination-list"}, 
                arrowLeftEl, 
                paginationListEl, 
                arrowRightEl
            )
        );
    }
});

/**
 * Calculate the middle of the position
 * @param currentPage
 * @param visiblePages
 * @returns {*}
 */
function getStartIndex(currentPage, visiblePages) {
    const middleCurrentRange = NumberUtils.divide(visiblePages, 2);
    const startIndexTarget = NumberUtils.subtract(currentPage, middleCurrentRange);

    return NumberUtils.isGreater(startIndexTarget, 0) ? startIndexTarget - 1: 0;
}

module.exports = Pagination;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/Pagination/Pagination.js
 **/